import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * SearchField, the label-wrapped search pill.
 *
 * CSS selector: `mobile/molecules.css` `.ds-search` (+ `--insheet`), with
 * `.ds-search__icon` and `.ds-search__input` for its parts.
 *
 * Doctrine: the `<label>` is the hit target, so tapping anywhere in the 44px
 * pill focuses the input, and the focus ring lands on the whole pill via
 * `:focus-within`. Input text stays inside the 15px to 16px guardrail;
 * bigness comes from the row padding, never from a larger font.
 *
 * `insheet` is the tighter rounded-rect flavour used inside a filter sheet.
 */
function SearchGlyph() {
  return (
    <svg
      className="ds-search__icon"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="1.8"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </svg>
  );
}

export const SearchField = React.forwardRef(function SearchField(
  { className, labelClassName, insheet = false, type = 'search', ...rest },
  ref,
) {
  return (
    <label className={cn('ds-search', insheet && 'ds-search--insheet', labelClassName)}>
      <SearchGlyph />
      <input ref={ref} type={type} className={cn('ds-search__input', className)} {...rest} />
    </label>
  );
});

export default SearchField;
